import DateBox from 'devextreme/ui/date_box';
import DropDownBox from 'devextreme/ui/drop_down_box';
import NumberBox from 'devextreme/ui/number_box';
import SelectBox from 'devextreme/ui/select_box';
import TextArea from 'devextreme/ui/text_area';
import TextBox from 'devextreme/ui/text_box';
import Scrollable from 'devextreme/ui/scroll_view/ui.scrollable';

export function setDefaultDevextremeOptions(): void {
  NumberBox.defaultOptions({
    options: {
      stylingMode: 'outlined',
    },
  });
  TextArea.defaultOptions({
    options: {
      stylingMode: 'outlined',
    },
  });
  DateBox.defaultOptions({
    options: {
      stylingMode: 'outlined',
      calendarOptions: { firstDayOfWeek: 0 },
    },
  });
  SelectBox.defaultOptions({
    options: {
      stylingMode: 'outlined',
    },
  });
  DropDownBox.defaultOptions({
    options: {
      stylingMode: 'outlined',
    },
  });
  TextBox.defaultOptions({
    options: {
      stylingMode: 'outlined',
    },
  });
  Scrollable.defaultOptions({
    options: {
      showScrollbar: 'onHover',
    },
  });
}
